var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02512 13.9749C1 12.9497 1 11.2998 1 8C1 4.70017 1 3.05026 2.02512 2.02512C3.05026 1 4.70017 1 8 1C11.2998 1 12.9497 1 13.9749 2.02512C15 3.05026 15 4.70017 15 8C15 11.2998 15 12.9497 13.9749 13.9749C12.9497 15 11.2998 15 8 15C4.70017 15 3.05026 15 2.02512 13.9749Z",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.78955H15",
    stroke: "#212129",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.73633H15",
    stroke: "#212129",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.6841H15",
    stroke: "#212129",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.0001V5.78955",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableInactive);
export default __webpack_public_path__ + "static/media/table-inactive.e7b562618558d1a9778806b77c3c35ea.svg";
export { ForwardRef as ReactComponent };